import { render, staticRenderFns } from "./deposit_gatewayamb.vue?vue&type=template&id=71937d60&scoped=true&"
import script from "./deposit_gatewayamb.vue?vue&type=script&lang=js&"
export * from "./deposit_gatewayamb.vue?vue&type=script&lang=js&"
import style0 from "./deposit_gatewayamb.vue?vue&type=style&index=0&id=71937d60&prod&scoped=true&lang=css&"
import style1 from "./deposit_gatewayamb.vue?vue&type=style&index=1&id=71937d60&prod&lang=scss&scoped=true&"
import style2 from "./deposit_gatewayamb.vue?vue&type=style&index=2&id=71937d60&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71937d60",
  null
  
)

export default component.exports